<script setup lang="ts">
    import type { Comment } from '@/types';
    import EmployeeAvatar from '@/components/EmployeeAvatar.vue';
    import { computed } from 'vue';
    import { useI18n } from 'vue-i18n';

    const { t } = useI18n();

    const props = defineProps<{
        comment: Comment;
    }>();

    const name = computed(() => {
        if (props.comment.author_is_user) {
            return t('translations.you');
        }

        return props.comment.user?.name ?? t('translations.deleted');
    });

    const email = computed(() => {
        return props.comment.user?.email ?? null;
    });
</script>

<template>
    <div class="flex gap-2">
        <EmployeeAvatar
            :user="comment.user"
            class="size-6 border-none shadow-sm"
        />
        <div class="flex flex-col gap-1.5">
            <div class="flex items-baseline gap-2 pt-1">
                <span class="text-xs font-bold">{{ name }}</span>
                <a
                    v-if="email"
                    :href="`mailto:${email}`"
                    class="text-secondary text-xs leading-none hover:underline"
                >
                    {{ email }}
                </a>
                <span class="text-muted-foreground text-[10px]">
                    {{ comment.last_created_at }}
                </span>
            </div>
            <div class="text-xs leading-4">
                {{ comment.body }}
            </div>
        </div>
    </div>
</template>
